// extracted by mini-css-extract-plugin
export var activityContainer = "_o0-0";
export var typingIndicatorContainer = "_o0-1";
export var typingIndicatorDot = "_o0-2";
export var wave = "_o0-3";